import BaseEnum from './BaseEnum';

class DirectMailrRevenue extends BaseEnum {
  fieldsMap = {
    'territory': 'Territory',
    'customer': 'Customer',
    'branch': 'Branch',
    'quantity': 'Quantity',
    'orderscount': 'Orders Count',
    'billperiod': 'Billing period',
    'total': 'Total Spend',
    'grosstotal': 'Gross Total',
  }
}

export default DirectMailrRevenue.make();